export const GRNS_RESET_STATE = 'GRNS_RESET_STATE';
export const GRNS_CURRENT_ITEM = 'GRNS_CURRENT_ITEM';

export const GRNS_REQUEST_LOADING = 'GRNS_REQUEST_LOADING';
export const GRNS_REQUEST_SUCCESS = 'GRNS_REQUEST_SUCCESS';
export const GRNS_REQUEST_FAILED = 'GRNS_REQUEST_FAILED';

export const GRNS_CURRENT_ACTION = 'GRNS_CURRENT_ACTION';
export const GRNS_RESET_ACTION = 'GRNS_RESET_ACTION';
